import { z } from 'zod';

export enum EmployeeEditTab {
  GENERAL_INFORMATION = 'general-information',
  PERSONAL_INFORMATION = 'personal-information',
  OFF_BOARDING = 'off-boarding',
  JOB_HISTORY = 'job-history',
  EXTERNAL_ACCOUNTS = 'external-accounts',
  PERMISSION = 'permission',
  PERFORMANCE_REVIEW = 'performance-review',
  PROBATION_REVIEW = 'probation-review',
  IDP = 'idp',
  MANAGERIAL_ACCOUNTING = 'managerial-accounting',
  MY_SIGNATURE = 'my-signature',
}

export const EmployeeTabParser = z.object({
  tab: z.nativeEnum(EmployeeEditTab).optional().default(EmployeeEditTab.GENERAL_INFORMATION),
}) satisfies z.ZodType<
  {
    tab?: EmployeeEditTab;
  },
  z.ZodTypeDef,
  unknown
>;

export type EmployeeEditTabFilterType = z.infer<typeof EmployeeTabParser>;
